

























































































import { useUser } from '~/modules/customer/composables/useUser';
import {
  ref,
  computed,
  defineComponent,
  onMounted,
  useContext,
  useRouter,
  watch, useFetch,
} from '@nuxtjs/composition-api';
import { useUiState } from '~/composables';
import { useCart } from '~/modules/checkout/composables/useCart';
import {AttributesEnum} from '~/modules/stocklist/enums/AttributesEnum';
import {useCustomerStore} from '~/modules/customer/stores/customer';

export default defineComponent({
  setup() {
    const customerStore = useCustomerStore();
    const {cart, load: loadCart} = useCart();
    const {user, load: loadUser, loading: userLoading, isAuthenticated, logout} = useUser();
    const router = useRouter();
    const {app} = useContext();
    const {toggleLoginModal} = useUiState();
    const goToCart = async () => {
      await router.push(app.localeRoute({ name: 'cart' }));
    };
    const gotToMyAccount = async () => {
      await router.push(app.localeRoute({ name: 'my-account' }));
    };
    const logOutUser = async () => {
      await logout({});
      await router.push(app.localeRoute({ name: 'stock-list' }));
    };

    const userName = computed(() => {
      return user.value?.firstname + ' ' + user.value?.lastname
    });

    onMounted(async () => {
      // Priorität 1: Zuerst User validieren (Token-Check), dann Cart – vermeidet customer + customerCart mit ungültigem Token
      await loadUser();
      await loadCart();
      if (isAuthenticated.value && user.value?.firstname === undefined) {
        await logOutUser();
      }
    });

    return {
      cartItems: computed(() => (cart.value?.items?.length ?? 0)),
      toggleLoginModal,
      logOutUser,
      goToCart,
      gotToMyAccount,
      isAuthenticated,
      userName,
      user,
      cart,
      userLoading,
    };
  },
});
